/** @format */

import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی‌تواند بیشتر از 190 کاراکتر باشد'),
  sort_order: Yup.number()
    .typeError('ترتیب باید عدد باشد')
    .nullable()
    .min(0, 'ترتیب نمی‌تواند منفی باشد'),
  is_active: Yup.boolean(),
});

const EditPosition = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);

  useEffect(() => {
    const getPosition = async () => {
      setLoading(true);
      await useApi.get(
        `/position/${id}`,
        {},
        (res) => {
          eventContext.position = res.data.data;
          setLoading(false);
        },
        () => {
          setLoading(false);
          error('خطایی در هنگام دریافت اطلاعات پیش آمده است.');
        },
      );
    };
    getPosition();
  }, [id]);

  const onSubmitForm = async (values) => {
    setSubmitFormLoading(true);
    await useApi.put(
      `/position/${id}`,
      values,
      () => {
        success('سمت با موفقیت ویرایش شد');
        navigate('/panel/setting/positions', { replace: true });
      },
      () => {
        setSubmitFormLoading(false);
        error('خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Master>
      <Formik
        enableReinitialize
        initialValues={{
          name: eventContext.position?.name ?? '',
          sort_order: eventContext.position?.sort_order ?? 0,
          is_active: eventContext.position?.is_active ?? true,
        }}
        onSubmit={onSubmitForm}
        validationSchema={validationSchema}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <div className='row border rounded p-2 mt-3'>
              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <label>عنوان سمت</label>
                  <input
                    name='name'
                    value={values.name}
                    onChange={handleChange}
                    type='text'
                    className='form-control'
                  />
                  <ErrorMessage error={errors.name} />
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <label>ترتیب نمایش</label>
                  <input
                    name='sort_order'
                    value={values.sort_order}
                    onChange={handleChange}
                    type='number'
                    min='0'
                    className='form-control'
                  />
                  <ErrorMessage error={errors.sort_order} />
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='form-group'>
                  <label>وضعیت</label>
                  <select
                    name='is_active'
                    value={values.is_active ? '1' : '0'}
                    onChange={(e) =>
                      setFieldValue('is_active', e.target.value === '1')
                    }
                    className='form-control'
                  >
                    <option value='1'>فعال</option>
                    <option value='0'>غیرفعال</option>
                  </select>
                </div>
              </div>
              <div className='col-12'>
                <button type='submit' className='btn btn-info btn-sm f-14'>
                  {submitFormLoading ? (
                    <span
                      className='spinner-border spinner-border-sm'
                      role='status'
                    ></span>
                  ) : (
                    'ذخیره تغییرات'
                  )}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default EditPosition;
